module.exports = __webpack_public_path__ + "static/media/logo_mioconcept.c6465507.png";